<template>
  <div v-if="broadcasts.length" class="space-y-2 mb-4">
    <div v-for="b in broadcasts" :key="b.id"
      class="rounded-lg border-2 p-3 flex items-start gap-3 shadow"
      :class="b.type === 'outage'
        ? 'border-red-500 bg-red-50 dark:bg-red-900/30'
        : 'border-blue-500 bg-blue-50 dark:bg-blue-900/30'">
      <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
        :class="b.type === 'outage' ? 'bg-red-500' : 'bg-blue-600'">!</div>
      <div class="flex-1 min-w-0">
        <h4 class="text-sm font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2 flex-wrap">
          {{ b.subject }}
          <span class="rounded-full px-2 py-0.5 text-xs font-bold text-white uppercase"
            :class="b.type === 'outage' ? 'bg-red-500' : 'bg-blue-600'">
            {{ b.type === 'outage' ? 'Outage' : 'Notice' }}
          </span>
        </h4>
        <p class="text-xs text-gray-700 dark:text-gray-200 mt-1 whitespace-pre-line">{{ b.message }}</p>
        <div class="mt-2 flex items-center gap-3 text-xs text-gray-500 dark:text-gray-300 flex-wrap">
          <span>Posted by AIM IT Services</span>
          <button v-if="b.can_watch && !watched[b.id]" type="button" @click="follow(b)" :disabled="following !== null"
            class="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-semibold hover:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed"
            :class="b.type === 'outage' ? 'border-red-500 text-red-700 dark:text-red-200' : 'border-blue-600 text-blue-700 dark:text-blue-200'">
            {{ following === b.id ? 'Adding…' : '+ Keep me updated' }}
          </button>
          <span v-else-if="b.can_watch && watched[b.id]" class="text-green-600 dark:text-green-300 font-semibold">
            ✓ You'll get updates
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import BroadcastService from '@/services/BroadcastService';

const { proxy } = getCurrentInstance();
const updateLoading = (n) => proxy?.$updateLoading?.(n);

const broadcasts = ref([]);
const watched = ref({});
// Id of the broadcast being followed — blocks repeat clicks while in flight.
const following = ref(null);

const load = async () => {
  try {
    const { data } = await BroadcastService.getActive();
    broadcasts.value = Array.isArray(data) ? data : (data.data || []);
  } catch (e) {
    // Non-fatal — the page works without the banner.
  }
};

const follow = async (b) => {
  if (following.value !== null) return;
  following.value = b.id;
  updateLoading(1);
  try {
    await BroadcastService.watch(b.id);
    watched.value = { ...watched.value, [b.id]: true };
  } catch (e) {
    // Non-fatal — silently ignore; the banner stays as-is.
  } finally {
    following.value = null;
    updateLoading(-1);
  }
};

onMounted(load);
</script>
